const CATCH_MSG = "Something Went Wrong"

export default CATCH_MSG